import { MealyModelType } from '../mealyModelType';
import AmpelSystem from './AmpelSystem.svelte';
export const mealyModelAmpel = {
    component: AmpelSystem,
    type: MealyModelType.AMPELSYSTEM,
    alphabet: ['Taster', 'Timer'],
    outputs: ['rot', 'rot_Timer', 'grün', 'grün_Timer'],
};
